import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { ApplicationEnum } from 'src/app/shared/enums/application.enum';
import { InAppNotificationPreference } from 'src/app/in-app-notifications/models/in-app-notification-preference.model';

@Injectable({
    providedIn: 'root'
})
export class InAppNotificationPreferencesService {
    private readonly coreApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'in-app-notification-preferences');
    }

    getInAppNotificationPreferences(): Observable<InAppNotificationPreference[]> {
        return this.http.get<InAppNotificationPreference[]>(
            `${this.coreApiPath}?applicationId=${ApplicationEnum.NovaWeb}`
        );
    }

    updateInAppNotificationPreference(
        preferenceId: number,
        isEnabled: boolean
    ): Observable<InAppNotificationPreference> {
        return this.http.put<InAppNotificationPreference>(`${this.coreApiPath}/${preferenceId}`, isEnabled);
    }
}
